import styled from 'styled-components';

export const StyledVictoryMessage = styled.div`
    position: fixed;
    top: 180px;
    left: 875px;
    color: red;
    font-style: italic;
    font-family: Georgia, serif;
    font-size: 25px;
    font-weight: bold;
`;